import { useId } from "react";
import { cn } from "@repo/utils/css";

function IconSuppleantLogo({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 71.79 82.9"
      fill="currentColor"
      // viewBox="0 0 256 256"
      // role="img"
      // xmlns="http://www.w3.org/2000/svg"
      className={cn("", className)}
      {...props}
    >
      <defs>
        <style>
          {`.cls-1 { fill: url(#linear-gradient); }
            .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 { stroke-width: 0px; }
            .cls-2 { fill: url(#linear-gradient-6); }
            .cls-3 { fill: url(#linear-gradient-5); }
            .cls-4 { fill: url(#linear-gradient-2); }
            .cls-5 { fill: url(#linear-gradient-7); }
            .cls-6 { fill: url(#linear-gradient-3); }
            .cls-7 { fill: url(#linear-gradient-4); }`}
        </style>
        <linearGradient
          id="linear-gradient"
          x1="18.49"
          y1="39.72"
          x2="49.34"
          y2="79.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#f9d4ff" />
          <stop offset="1" stopColor="#e97aff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="7.31"
          y1="-14.06"
          x2="62.66"
          y2="93.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7736ff" />
          <stop offset=".24" stopColor="#9246ff" />
          <stop offset=".75" stopColor="#d870ff" />
          <stop offset="1" stopColor="#fd86ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="4267.46"
          y1="84.66"
          x2="4307.78"
          y2="-5.45"
          gradientTransform="translate(4314.02) rotate(-180) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2577ff" />
          <stop offset="1" stopColor="#52f8ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1="4270.18"
          y1="58.13"
          x2="4283.75"
          y2="-5.78"
          href="#linear-gradient-3"
        />
        <linearGradient
          id="linear-gradient-5"
          x1="41.53"
          y1="136.04"
          x2="54.73"
          y2="56.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7736ff" />
          <stop offset=".29" stopColor="#a04eff" />
          <stop offset=".77" stopColor="#e276ff" />
          <stop offset="1" stopColor="#fd86ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1="4275.53"
          y1="46.55"
          x2="4279.1"
          y2="25.3"
          gradientTransform="translate(4314.02) rotate(-180) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#263cff" />
          <stop offset="1" stopColor="#3e63ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-7"
          x1="4281.32"
          y1="-3.29"
          x2="4301.84"
          y2="30.11"
          gradientTransform="translate(4314.02) rotate(-180) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#48c8ff" />
          <stop offset="1" stopColor="#3a92ff" />
        </linearGradient>
      </defs>
      <g>
        <g>
          <polygon
            className="cls-1"
            points="71.79 62.17 35.9 82.9 0 62.17 35.9 41.45 71.79 62.17"
          />
          <polygon
            className="cls-4"
            points="71.79 41.45 35.9 62.17 0 41.45 35.9 20.72 71.79 41.45"
          />
          <polygon
            className="cls-6"
            points="0 20.72 0 41.45 35.9 20.72 35.9 0 0 20.72"
          />
          <polygon
            className="cls-7"
            points="71.79 20.72 35.9 41.45 0 20.72 35.9 0 71.79 20.72"
          />
          <polygon
            className="cls-3"
            points="35.9 62.17 35.9 82.9 71.79 62.17 71.79 41.45 35.9 62.17"
          />
          <polygon
            className="cls-2"
            points="35.9 20.72 53.84 31.09 35.9 41.45 17.95 31.09 35.9 20.72"
          />
          <polygon
            className="cls-5"
            points="0 20.72 17.95 31.09 35.9 20.72 35.9 0 0 20.72"
          />
        </g>
      </g>
    </svg>
  );
}

function IconSuppleant({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      // data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      // xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 275.17 67.09"
      fill="currentColor"
      // viewBox="0 0 256 256"
      // role="img"
      // xmlns="http://www.w3.org/2000/svg"
      className={cn("", className)}
      {...props}
    >
      <defs>
        <style>
          {`
            .cls-1 {
              fill: url(#linear-gradient);
            }

            .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {
              stroke-width: 0px;
            }

            .cls-2 {
              fill: url(#linear-gradient-6);
            }

            .cls-3 {
              fill: url(#linear-gradient-5);
            }

            .cls-4 {
              fill: url(#linear-gradient-2);
            }

            .cls-5 {
              fill: url(#linear-gradient-7);
            }

            .cls-6 {
              fill: url(#linear-gradient-3);
            }

            .cls-7 {
              fill: #050260;
            }

            .cls-8 {
              fill: url(#linear-gradient-4);
            }
          `}
        </style>
        <linearGradient
          id="linear-gradient"
          x1="14.97"
          y1="32.15"
          x2="39.93"
          y2="64.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#f9d4ff" />
          <stop offset="1" stopColor="#e97aff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="5.91"
          y1="-11.38"
          x2="50.71"
          y2="75.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7736ff" />
          <stop offset=".24" stopColor="#9246ff" />
          <stop offset=".75" stopColor="#d870ff" />
          <stop offset="1" stopColor="#fd86ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="4266.26"
          y1="68.52"
          x2="4298.89"
          y2="-4.41"
          gradientTransform="translate(4303.94) rotate(-180) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2577ff" />
          <stop offset="1" stopColor="#52f8ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1="4268.46"
          y1="47.04"
          x2="4279.44"
          y2="-4.68"
          xlinkHref="#linear-gradient-3"
        />
        <linearGradient
          id="linear-gradient-5"
          x1="33.61"
          y1="110.1"
          x2="44.3"
          y2="46"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7736ff" />
          <stop offset=".29" stopColor="#a04eff" />
          <stop offset=".77" stopColor="#e276ff" />
          <stop offset="1" stopColor="#fd86ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1="4272.79"
          y1="37.67"
          x2="4275.68"
          y2="20.48"
          gradientTransform="translate(4303.94) rotate(-180) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#263cff" />
          <stop offset="1" stopColor="#3e63ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-7"
          x1="4277.47"
          y1="-2.66"
          x2="4294.09"
          y2="24.37"
          gradientTransform="translate(4303.94) rotate(-180) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#48c8ff" />
          <stop offset="1" stopColor="#3a92ff" />
        </linearGradient>
      </defs>
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <g>
            <polygon
              className="cls-1"
              points="58.1 50.32 29.05 67.09 0 50.32 29.05 33.55 58.1 50.32"
            />
            <polygon
              className="cls-4"
              points="58.1 33.55 29.05 50.32 0 33.55 29.05 16.77 58.1 33.55"
            />
            <polygon
              className="cls-6"
              points="0 16.77 0 33.55 29.05 16.77 29.05 0 0 16.77"
            />
            <polygon
              className="cls-8"
              points="58.1 16.77 29.05 33.55 0 16.77 29.05 0 58.1 16.77"
            />
            <polygon
              className="cls-3"
              points="29.05 50.32 29.05 67.09 58.1 50.32 58.1 33.55 29.05 50.32"
            />
            <polygon
              className="cls-2"
              points="29.05 16.77 43.58 25.16 29.05 33.55 14.53 25.16 29.05 16.77"
            />
            <polygon
              className="cls-5"
              points="0 16.77 14.53 25.16 29.05 16.77 29.05 0 0 16.77"
            />
          </g>
          <g>
            <path
              className="cls-7"
              d="m91.01,37.04c0,5.89-4.61,10.25-11.87,10.25-6.62,0-11.62-5.04-11.62-10.85h6.66c.3,2.65,2.22,4.7,4.95,4.7,3.16,0,5.25-1.49,5.25-4.1s-2.73-3.2-7.26-4.27c-5-1.15-9.18-3.59-9.18-7.99,0-5.64,4.36-9.61,11.19-9.61,6.15,0,11.32,4.1,11.32,9.52h-6.79c-.56-1.92-2.43-3.37-4.53-3.37-2.56,0-4.57,1.41-4.57,3.2,0,2.18,4.14,3.33,8.2,4.06,4.18.77,8.24,3.59,8.24,8.46Z"
            />
            <path
              className="cls-7"
              d="m99.46,23.54v11.53c0,3.54,1.75,6.41,5.3,6.41s5.3-2.86,5.3-6.41v-11.53h6.41v11.53c0,6.75-4.61,12.21-11.7,12.21s-11.7-5.47-11.7-12.21v-11.53h6.41Z"
            />
            <path
              className="cls-7"
              d="m144.17,35.07c0,6.75-5.68,12.21-12.68,12.21-2.43,0-4.65-.98-6.28-2.56v9.57h-6.41v-19.22c0-6.75,5.68-12.21,12.68-12.21s12.68,5.47,12.68,12.21Zm-6.41,0c0-3.55-2.86-6.41-6.41-6.41s-6.41,2.86-6.41,6.41,2.86,6.41,6.41,6.41,6.41-2.86,6.41-6.41Z"
            />
            <path
              className="cls-7"
              d="m171.24,35.07c0,6.75-5.68,12.21-12.68,12.21-2.43,0-4.66-.98-6.28-2.56v9.57h-6.41v-19.22c0-6.75,5.68-12.21,12.68-12.21s12.68,5.47,12.68,12.21Zm-6.41,0c0-3.55-2.86-6.41-6.41-6.41s-6.41,2.86-6.41,6.41,2.86,6.41,6.41,6.41,6.41-2.86,6.41-6.41Z"
            />
            <path className="cls-7" d="m173.16,15.85h6.41v30.75h-6.41V15.85Z" />
            <path
              className="cls-7"
              d="m207.11,35.07c0,.77-.08,1.49-.21,2.22h-18.62c.94,2.43,3.25,4.19,6.02,4.19,2.05,0,3.89-.98,5.04-2.48h7.09c-1.71,4.83-6.49,8.29-12.13,8.29-7.09,0-12.81-5.47-12.81-12.21s5.72-12.21,12.81-12.21,12.81,5.47,12.81,12.21Zm-6.79-2.22c-.94-2.43-3.29-4.18-6.02-4.18s-5.08,1.75-6.02,4.18h12.04Z"
            />
            <path
              className="cls-7"
              d="m233.24,35.07v11.53h-5.98v-2.86c-1.45,2.13-3.93,3.54-6.7,3.54-7,0-12.68-5.47-12.68-12.21s5.68-12.21,12.68-12.21,12.68,5.47,12.68,12.21Zm-6.15,0c0-3.55-2.86-6.41-6.41-6.41s-6.41,2.86-6.41,6.41,2.86,6.41,6.41,6.41,6.41-2.86,6.41-6.41Z"
            />
            <path
              className="cls-7"
              d="m247.97,22.86c7.09,0,11.96,5.47,11.96,12.21v11.53h-6.41v-11.53c0-3.55-2.01-6.41-5.55-6.41s-5.55,2.86-5.55,6.41v11.53h-6.41v-11.53c0-6.75,4.87-12.21,11.96-12.21Z"
            />
            <path
              className="cls-7"
              d="m268.77,15.85v7.69h6.41v5.47h-6.41v6.06c0,3.54,2.86,6.41,6.41,6.41v5.81h-.85c-7.09,0-11.96-5.47-11.96-12.21V15.85h6.41Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function IconFaqtory({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 130 69"
      className={className}
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="10"
        viewBox="851 832.7999877929688 163 285.20001220703125"
        height="49"
        width="28"
        preserveAspectRatio="xMinYMin"
      >
        <polygon
          points="851,1025.1 851,1079.9 851,1081.1 851.9,1080.5 910.1,1118 910.1,1046.6 1014,985.9 1014,918.1 851,1013.3"
          style={{ fill: "#109EFF" }}
        />
        <polygon
          points="851,927.9 851,995.8 1014,900.6 1014,832.8"
          style={{ fill: "#109EFF" }}
        />
      </svg>
      <svg x="38" y="18" width="92" height="33">
        <text
          x="0"
          y="25"
          fontFamily="Arial, sans-serif"
          fontSize="24"
          fontWeight="bold"
          fill="currentColor"
        >
          Faqtory
        </text>
      </svg>
    </svg>
  );
}

function IconFaqtoryLogo({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="851 832.8 163 285.2"
      className={className}
      {...props}
    >
      <polygon
        points="851,1025.1 851,1079.9 851,1081.1 851.9,1080.5 910.1,1118 910.1,1046.6 1014,985.9 1014,918.1 851,1013.3"
        fill="currentColor"
      />
      <polygon
        points="851,927.9 851,995.8 1014,900.6 1014,832.8"
        fill="currentColor"
      />
    </svg>
  );
}

function IconMicrosoftOffice({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      enableBackground="new 0 0 128 128"
      version="1.1"
      viewBox="0 0 128 128"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={cn("", className)}
      {...props}
    >
      <style>
        {`.st0{fill:#21A365;}
          .st1{fill:#107C41;}
          .st2{fill:#185B37;}
          .st3{fill:#33C481;}
          .st4{fill:#17864C;}
          .st5{fill:#FFFFFF;}
          .st6{fill:#036C70;}
          .st7{fill:#1A9BA1;}
          .st8{fill:#37C6D0;}
          .st9{fill:#04878B;}
          .st10{fill:#4F59CA;}
          .st11{fill:#7B82EA;}
          .st12{fill:#4C53BB;}
          .st13{fill:#0F78D5;}
          .st14{fill:#29A7EB;}
          .st15{fill:#0358A8;}
          .st16{fill:#0F79D6;}
          .st17{fill:#038387;}
          .st18{fill:#048A8E;}
          .st19{fill:#C8421D;}
          .st20{fill:#FF8F6A;}
          .st21{fill:#ED6B47;}
          .st22{fill:#891323;}
          .st23{fill:#AF2131;}
          .st24{fill:#C94E60;}
          .st25{fill:#E08195;}
          .st26{fill:#B42839;}
          .st27{fill:#0464B8;}
          .st28{fill:#0377D4;}
          .st29{fill:#4FD8FF;}
          .st30{fill:#1681D7;}
          .st31{fill:#0178D4;}
          .st32{fill:#042071;}
          .st33{fill:#168FDE;}
          .st34{fill:#CA64EA;}
          .st35{fill:#7E1FAF;}
          .st36{fill:#AE4BD5;}
          .st37{fill:#9332BF;}
          .st38{fill:#7719AA;}
          .st39{fill:#0078D4;}
          .st40{fill:#1490DF;}
          .st41{fill:#0364B8;}
          .st42{fill:#28A8EA;}
          .st43{fill:#41A5ED;}
          .st44{fill:#2C7BD5;}
          .st45{fill:#195ABE;}
          .st46{fill:#103E91;}
          .st47{fill:#2166C3;}
          .st48{opacity:0.2;}`}
      </style>
      <g>
        <path
          className="st39"
          d="M5.9,90.2l66.6-27.7L39,42.7c0,0-3-1.7-7.7-2.3C14,40.8,0.1,54.9,0.1,72.3c0,6.9,2.2,13.3,5.9,18.5L5.9,90.2z"
        />
        <path
          className="st40"
          d="M123.4,92.8c2.8-4.2,4.5-9.2,4.5-14.6c0-13.8-10.8-25-24.3-25.9c0-0.1,0-0.2-0.1-0.3c-4.8-0.5-9.2,1.4-9.2,1.4l-21.8,9.1L123.4,92.8z"
        />
        <path
          className="st41"
          d="M72.5,62.6l21.8-9.1c0,0,4.5-1.9,9.2-1.4C99.3,34.9,83.7,22,65.2,22c-14,0-26.3,7.3-33.4,18.3c-0.2,0-0.3,0-0.5,0c4.8,0.6,7.7,2.3,7.7,2.3L72.5,62.6z"
        />
        <path
          className="st42"
          d="M72.6,62.6L6,90.2l0.1,0.6c5.8,8.1,15.3,13.4,26,13.4c1,0,2-0.1,3-0.1h65.9c0.4,0,0.7,0,1.1,0s0.7,0,1.1,0h0.1v0c8.4-0.4,15.8-4.8,20.2-11.3L72.6,62.6z"
        />
      </g>
    </svg>
  );
}

function IconGoogle({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      enableBackground="new 0 0 128 128"
      id="Social_Icons"
      version="1.1"
      viewBox="0 0 128 128"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={cn("", className)}
    >
      <g id="_x31__stroke">
        <g id="Google">
          <rect
            clipRule="evenodd"
            fill="none"
            fillRule="evenodd"
            height="128"
            width="128"
          />
          <path
            clipRule="evenodd"
            d="M27.585,64c0-4.157,0.69-8.143,1.923-11.881L7.938,35.648    C3.734,44.183,1.366,53.801,1.366,64c0,10.191,2.366,19.802,6.563,28.332l21.558-16.503C28.266,72.108,27.585,68.137,27.585,64"
            fill="#FBBC05"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M65.457,26.182c9.031,0,17.188,3.2,23.597,8.436L107.698,16    C96.337,6.109,81.771,0,65.457,0C40.129,0,18.361,14.484,7.938,35.648l21.569,16.471C34.477,37.033,48.644,26.182,65.457,26.182"
            fill="#EA4335"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M65.457,101.818c-16.812,0-30.979-10.851-35.949-25.937    L7.938,92.349C18.361,113.516,40.129,128,65.457,128c15.632,0,30.557-5.551,41.758-15.951L86.741,96.221    C80.964,99.86,73.689,101.818,65.457,101.818"
            fill="#34A853"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M126.634,64c0-3.782-0.583-7.855-1.457-11.636H65.457v24.727    h34.376c-1.719,8.431-6.397,14.912-13.092,19.13l20.474,15.828C118.981,101.129,126.634,84.861,126.634,64"
            fill="#4285F4"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
}

function IconLinkedIn({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={cn("", className)}
      {...props}
    >
      <style>{`.st0-linked{fill:#2A7AB9;}`}</style>
      <g>
        <path
          className="st0-linked"
          d="M273,233.8v-0.7c-0.1,0.2-0.3,0.5-0.5,0.7H273z"
        />
        <path
          className="st0-linked"
          d="M447.7,29.6H64.2C45.9,29.6,31,44.1,31,62v388c0,17.9,14.9,32.4,33.2,32.4h383.5c18.4,0,33.3-14.5,33.3-32.4V62C481,44.1,466.1,29.6,447.7,29.6z M167.4,408.7h-68V204.2h68V408.7z M133.4,176.2H133c-22.8,0-37.5-15.7-37.5-35.3c0-20.1,15.2-35.3,38.4-35.3c23.3,0,37.6,15.3,38,35.3C171.9,160.5,157.1,176.2,133.4,176.2z M412.5,408.7h-68V299.2c0-27.5-9.8-46.2-34.4-46.2c-18.8,0-30,12.6-34.9,24.9c-1.8,4.4-2.2,10.5-2.2,16.6v114.2h-68c0,0,0.9-185.3,0-204.5h68v28.9c9-13.9,25.2-33.8,61.3-33.8c44.7,0,78.2,29.2,78.2,92.1V408.7z"
        />
      </g>
    </svg>
  );
}

function IconFacebook({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      data-name="1-facebook"
      id="_1-facebook"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("", className)}
      {...props}
    >
      <defs>
        <style>
          {`.cls-1{fill:#385997;}
            .cls-2{fill:#fff;}`}
        </style>
      </defs>
      <title>Facebook</title>
      <rect className="cls-1" height="64" rx="11.2" ry="11.2" width="64" />
      <path
        className="cls-2"
        d="M54.4,29.6h-10V22c0-1.86,2.14-2,2.8-2H54V9.6H47.2C39.67,9.6,34,14.93,34,22v7.6H25.6V40H34V64H44.4V40h8.4Z"
      />
    </svg>
  );
}

function IconAI({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 256 256"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M197.58,129.06l-51.61-19-19-51.65a15.92,15.92,0,0,0-29.88,0L78.07,110l-51.65,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0l19-51.61,51.65-19a15.92,15.92,0,0,0,0-29.88ZM140.39,163a15.87,15.87,0,0,0-9.43,9.43l-19,51.46L93,172.39A15.87,15.87,0,0,0,83.61,163h0L32.15,144l51.46-19A15.87,15.87,0,0,0,93,115.61l19-51.46,19,51.46a15.87,15.87,0,0,0,9.43,9.43l51.46,19ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z"></path>
    </svg>
  );
}

function IconNextChat({
  className,
  inverted,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  const id = useId();

  return (
    <svg
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <defs>
        <linearGradient
          id={`gradient-${id}-1`}
          x1="10.6889"
          y1="10.3556"
          x2="13.8445"
          y2="14.2667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={inverted ? "white" : "black"} />
          <stop
            offset={1}
            stopColor={inverted ? "white" : "black"}
            stopOpacity={0}
          />
        </linearGradient>
        <linearGradient
          id={`gradient-${id}-2`}
          x1="11.7555"
          y1="4.8"
          x2="11.7376"
          y2="9.50002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={inverted ? "white" : "black"} />
          <stop
            offset={1}
            stopColor={inverted ? "white" : "black"}
            stopOpacity={0}
          />
        </linearGradient>
      </defs>
      <path
        d="M1 16L2.58314 11.2506C1.83084 9.74642 1.63835 8.02363 2.04013 6.39052C2.4419 4.75741 3.41171 3.32057 4.776 2.33712C6.1403 1.35367 7.81003 0.887808 9.4864 1.02289C11.1628 1.15798 12.7364 1.8852 13.9256 3.07442C15.1148 4.26363 15.842 5.83723 15.9771 7.5136C16.1122 9.18997 15.6463 10.8597 14.6629 12.224C13.6794 13.5883 12.2426 14.5581 10.6095 14.9599C8.97637 15.3616 7.25358 15.1692 5.74942 14.4169L1 16Z"
        fill={inverted ? "black" : "white"}
        stroke={inverted ? "black" : "white"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_91_2047"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={0}
        width={16}
        height={16}
      >
        <circle cx={9} cy={8} r={8} fill={inverted ? "black" : "white"} />
      </mask>
      <g mask="url(#mask0_91_2047)">
        <circle cx={9} cy={8} r={8} fill={inverted ? "black" : "white"} />
        <path
          d="M14.2896 14.0018L7.146 4.8H5.80005V11.1973H6.87681V6.16743L13.4444 14.6529C13.7407 14.4545 14.0231 14.2369 14.2896 14.0018Z"
          fill={`url(#gradient-${id}-1)`}
        />
        <rect
          x="11.2222"
          y="4.8"
          width="1.06667"
          height="6.4"
          fill={`url(#gradient-${id}-2)`}
        />
      </g>
    </svg>
  );
}

function IconOpenAI({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <title>OpenAI icon</title>
      <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
    </svg>
  );
}

function IconVercel({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-label="Vercel logomark"
      role="img"
      viewBox="0 0 74 64"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path
        d="M37.5896 0.25L74.5396 64.25H0.639648L37.5896 0.25Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

function IconGitHub({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <title>GitHub</title>
      <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
    </svg>
  );
}

function IconSeparator({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      fill="none"
      shapeRendering="geometricPrecision"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M16.88 3.549L7.12 20.451"></path>
    </svg>
  );
}

function IconArrowDown({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="m205.66 149.66-72 72a8 8 0 0 1-11.32 0l-72-72a8 8 0 0 1 11.32-11.32L120 196.69V40a8 8 0 0 1 16 0v156.69l58.34-58.35a8 8 0 0 1 11.32 11.32Z" />
    </svg>
  );
}

function IconArrowRight({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="m221.66 133.66-72 72a8 8 0 0 1-11.32-11.32L196.69 136H40a8 8 0 0 1 0-16h156.69l-58.35-58.34a8 8 0 0 1 11.32-11.32l72 72a8 8 0 0 1 0 11.32Z" />
    </svg>
  );
}

function IconUser({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56 56.06 56.06 0 0 1-56-56Z" />
    </svg>
  );
}

function IconPlus({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M224 128a8 8 0 0 1-8 8h-80v80a8 8 0 0 1-16 0v-80H40a8 8 0 0 1 0-16h80V40a8 8 0 0 1 16 0v80h80a8 8 0 0 1 8 8Z" />
    </svg>
  );
}

function IconArrowElbow({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M200 32v144a8 8 0 0 1-8 8H67.31l34.35 34.34a8 8 0 0 1-11.32 11.32l-48-48a8 8 0 0 1 0-11.32l48-48a8 8 0 0 1 11.32 11.32L67.31 168H184V32a8 8 0 0 1 16 0Z" />
    </svg>
  );
}

function IconSpinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4 animate-spin", className)}
      {...props}
    >
      <path d="M232 128a104 104 0 0 1-208 0c0-41 23.81-78.36 60.66-95.27a8 8 0 0 1 6.68 14.54C60.15 61.59 40 93.27 40 128a88 88 0 0 0 176 0c0-34.73-20.15-66.41-51.34-80.73a8 8 0 0 1 6.68-14.54C208.19 49.64 232 87 232 128Z" />
    </svg>
  );
}

function IconMessage({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M216 48H40a16 16 0 0 0-16 16v160a15.84 15.84 0 0 0 9.25 14.5A16.05 16.05 0 0 0 40 240a15.89 15.89 0 0 0 10.25-3.78.69.69 0 0 0 .13-.11L82.5 208H216a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16ZM40 224Zm176-32H82.5a16 16 0 0 0-10.3 3.75l-.12.11L40 224V64h176Z" />
    </svg>
  );
}

function IconTrash({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16ZM96 40a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v8H96Zm96 168H64V64h128Zm-80-104v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Zm48 0v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Z" />
    </svg>
  );
}

function IconRefresh({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M197.67 186.37a8 8 0 0 1 0 11.29C196.58 198.73 170.82 224 128 224c-37.39 0-64.53-22.4-80-39.85V208a8 8 0 0 1-16 0v-48a8 8 0 0 1 8-8h48a8 8 0 0 1 0 16H55.44C67.76 183.35 93 208 128 208c36 0 58.14-21.46 58.36-21.68a8 8 0 0 1 11.31.05ZM216 40a8 8 0 0 0-8 8v23.85C192.53 54.4 165.39 32 128 32c-42.82 0-68.58 25.27-69.66 26.34a8 8 0 0 0 11.3 11.34C69.86 69.46 92 48 128 48c35 0 60.24 24.65 72.56 40H168a8 8 0 0 0 0 16h48a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8Z" />
    </svg>
  );
}

function IconStop({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88Zm24-120h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8Zm-8 48h-32v-32h32Z" />
    </svg>
  );
}

function IconSidebar({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M216 40H40a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16ZM40 56h40v144H40Zm176 144H96V56h120v144Z" />
    </svg>
  );
}

function IconMoon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M233.54 142.23a8 8 0 0 0-8-2 88.08 88.08 0 0 1-109.8-109.8 8 8 0 0 0-10-10 104.84 104.84 0 0 0-52.91 37A104 104 0 0 0 136 224a103.09 103.09 0 0 0 62.52-20.88 104.84 104.84 0 0 0 37-52.91 8 8 0 0 0-1.98-7.98Zm-44.64 48.11A88 88 0 0 1 65.66 67.11a89 89 0 0 1 31.4-26A106 106 0 0 0 96 56a104.11 104.11 0 0 0 104 104 106 106 0 0 0 14.92-1.06 89 89 0 0 1-26.02 31.4Z" />
    </svg>
  );
}

function IconInfoCircled({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      fill="none"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path
        d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

function IconReset({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      fill="none"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path
        d="M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

function IconSun({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M120 40V16a8 8 0 0 1 16 0v24a8 8 0 0 1-16 0Zm72 88a64 64 0 1 1-64-64 64.07 64.07 0 0 1 64 64Zm-16 0a48 48 0 1 0-48 48 48.05 48.05 0 0 0 48-48ZM58.34 69.66a8 8 0 0 0 11.32-11.32l-16-16a8 8 0 0 0-11.32 11.32Zm0 116.68-16 16a8 8 0 0 0 11.32 11.32l16-16a8 8 0 0 0-11.32-11.32ZM192 72a8 8 0 0 0 5.66-2.34l16-16a8 8 0 0 0-11.32-11.32l-16 16A8 8 0 0 0 192 72Zm5.66 114.34a8 8 0 0 0-11.32 11.32l16 16a8 8 0 0 0 11.32-11.32ZM48 128a8 8 0 0 0-8-8H16a8 8 0 0 0 0 16h24a8 8 0 0 0 8-8Zm80 80a8 8 0 0 0-8 8v24a8 8 0 0 0 16 0v-24a8 8 0 0 0-8-8Zm112-88h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16Z" />
    </svg>
  );
}

function IconCopy({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M216 32H88a8 8 0 0 0-8 8v40H40a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-40h40a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8Zm-56 176H48V96h112Zm48-48h-32V88a8 8 0 0 0-8-8H96V48h112Z" />
    </svg>
  );
}

function IconCheck({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="m229.66 77.66-128 128a8 8 0 0 1-11.32 0l-56-56a8 8 0 0 1 11.32-11.32L96 188.69 218.34 66.34a8 8 0 0 1 11.32 11.32Z" />
    </svg>
  );
}

function IconDownload({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M224 152v56a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16v-56a8 8 0 0 1 16 0v56h160v-56a8 8 0 0 1 16 0Zm-101.66 5.66a8 8 0 0 0 11.32 0l40-40a8 8 0 0 0-11.32-11.32L136 132.69V40a8 8 0 0 0-16 0v92.69l-26.34-26.35a8 8 0 0 0-11.32 11.32Z" />
    </svg>
  );
}

function IconClose({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path d="M205.66 194.34a8 8 0 0 1-11.32 11.32L128 139.31l-66.34 66.35a8 8 0 0 1-11.32-11.32L116.69 128 50.34 61.66a8 8 0 0 1 11.32-11.32L128 116.69l66.34-66.35a8 8 0 0 1 11.32 11.32L139.31 128Z" />
    </svg>
  );
}

function IconEdit({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
      />
    </svg>
  );
}

function IconShare({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="m237.66 106.35-80-80A8 8 0 0 0 144 32v40.35c-25.94 2.22-54.59 14.92-78.16 34.91-28.38 24.08-46.05 55.11-49.76 87.37a12 12 0 0 0 20.68 9.58c11-11.71 50.14-48.74 107.24-52V192a8 8 0 0 0 13.66 5.65l80-80a8 8 0 0 0 0-11.3ZM160 172.69V144a8 8 0 0 0-8-8c-28.08 0-55.43 7.33-81.29 21.8a196.17 196.17 0 0 0-36.57 26.52c5.8-23.84 20.42-46.51 42.05-64.86C99.41 99.77 127.75 88 152 88a8 8 0 0 0 8-8V51.32L220.69 112Z" />
    </svg>
  );
}

function IconUsers({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M117.25 157.92a60 60 0 1 0-66.5 0 95.83 95.83 0 0 0-47.22 37.71 8 8 0 1 0 13.4 8.74 80 80 0 0 1 134.14 0 8 8 0 0 0 13.4-8.74 95.83 95.83 0 0 0-47.22-37.71ZM40 108a44 44 0 1 1 44 44 44.05 44.05 0 0 1-44-44Zm210.14 98.7a8 8 0 0 1-11.07-2.33A79.83 79.83 0 0 0 172 168a8 8 0 0 1 0-16 44 44 0 1 0-16.34-84.87 8 8 0 1 1-5.94-14.85 60 60 0 0 1 55.53 105.64 95.83 95.83 0 0 1 47.22 37.71 8 8 0 0 1-2.33 11.07Z" />
    </svg>
  );
}

function IconExternalLink({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M224 104a8 8 0 0 1-16 0V59.32l-66.33 66.34a8 8 0 0 1-11.32-11.32L196.68 48H152a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8Zm-40 24a8 8 0 0 0-8 8v72H48V80h72a8 8 0 0 0 0-16H48a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-72a8 8 0 0 0-8-8Z" />
    </svg>
  );
}

function IconChevronUpDown({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("h-4 w-4", className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M181.66 170.34a8 8 0 0 1 0 11.32l-48 48a8 8 0 0 1-11.32 0l-48-48a8 8 0 0 1 11.32-11.32L128 212.69l42.34-42.35a8 8 0 0 1 11.32 0Zm-96-84.68L128 43.31l42.34 42.35a8 8 0 0 0 11.32-11.32l-48-48a8 8 0 0 0-11.32 0l-48 48a8 8 0 0 0 11.32 11.32Z" />
    </svg>
  );
}

export {
  IconAI,
  IconEdit,
  IconNextChat,
  IconOpenAI,
  IconVercel,
  IconGitHub,
  IconSeparator,
  IconArrowDown,
  IconArrowRight,
  IconUser,
  IconPlus,
  IconArrowElbow,
  IconSpinner,
  IconMessage,
  IconTrash,
  IconRefresh,
  IconStop,
  IconSidebar,
  IconMoon,
  IconInfoCircled,
  IconReset,
  IconSun,
  IconCopy,
  IconCheck,
  IconDownload,
  IconClose,
  IconShare,
  IconUsers,
  IconFaqtory,
  IconFaqtoryLogo,
  IconExternalLink,
  IconChevronUpDown,
  IconSuppleant,
  IconSuppleantLogo,
  IconMicrosoftOffice,
  IconGoogle,
  IconLinkedIn,
  IconFacebook,
};
